import { styled } from '@mui/material/styles';

import Link from 'mui/components/elements/Link';

const StyledLink = styled(Link)(
  ({ theme }) => `
   color: ${theme.DS_palette.buttons.enabled} !important;
  `,
);

export { StyledLink };
